import React, { createContext, Dispatch, PropsWithChildren, SetStateAction, useContext } from 'react'
export type SupportedLanguage = 'US'|'FR'|'ES'

const RecipientContext = createContext(null)

const useRecipient = (): {recipient: any, token: string, setRecipient: Dispatch<SetStateAction<any>>, variables: any} => {
	const [recipient, token, setRecipient, variables] = useContext(RecipientContext)

	return {recipient, token, setRecipient, variables}
}

const useLanguage = () => {
	const [recipient, token, setRecipient, variables, language, setLanguage, defaultLanguage, setDefaultLanguage] = useContext(RecipientContext)

	return { language, setLanguage, defaultLanguage, setDefaultLanguage }
}

const useAiVideo = (): {aiVideoEnabled: boolean, setAiVideoEnabled: Dispatch<SetStateAction<boolean>>} => {
	const context = useContext(RecipientContext)
	const aiVideoEnabled = context[10]
	const setAiVideoEnabled = context[11]

	return {aiVideoEnabled, setAiVideoEnabled}
}

const useModal = (): {currentModalId: string, setCurrentModalId:Dispatch<SetStateAction<string>>} => {
	const context = useContext(RecipientContext);
	const currentModalId = context[8];
	const setCurrentModalId = context[9];

	return {currentModalId, setCurrentModalId}
}

const RecipientProvider = ({value, children}: PropsWithChildren<{value: [ recipient: any, token: string, setRecipient: Dispatch<SetStateAction<any>>, variables: any, language: SupportedLanguage, setLanguage: Dispatch<SetStateAction<SupportedLanguage>>, defaultLanguage: SupportedLanguage, setDefaultLanguage: Dispatch<SetStateAction<SupportedLanguage>>, currentModalId: string | null, setCurrentModalId:Dispatch<SetStateAction<string | null>>, aiVideoEnabled: boolean, setAiVideoEnabled: Dispatch<SetStateAction<boolean>>]}>) => (
	<RecipientContext.Provider value={value}>{children}</RecipientContext.Provider>
)

export { useRecipient, RecipientProvider, useLanguage, useModal, useAiVideo }